module.exports = __webpack_public_path__ + "img/unnamed6.28e28eee.png";